import { observer } from "mobx-react";
import React from "react";

const Workspace: React.FC = () => {
  return <div></div>;
};

export default observer(Workspace);
